import { toast } from '@/helpers/toast/toast.helper'
import { t } from 'i18next'
import { put } from 'redux-saga/effects'
import { updateUserAction } from '../../actions'
import { UserAuthenticated } from '../../types'
import { buildDataAccordingUserRole } from './helpers'

export function* updateUserSaga(action: ReturnType<typeof updateUserAction.request>) {
  try {
    const { currentCompanyId, userAuthenticated, navigate } = action.payload

    const userBelongsToCompany = yield isUserBelongsToCompany(currentCompanyId, userAuthenticated)

    if (!userBelongsToCompany) {
      throw new Error('Usuário não atende para essa empresa.')
    }

    const isAllowedUser = yield isAllowedUserOnCompany(currentCompanyId, userAuthenticated)

    if (!isAllowedUser) {
      throw new Error('Acesso não autorizado.')
    }

    const { userAttendCampaigns, userDepartments } = yield buildDataAccordingUserRole(
      userAuthenticated,
      currentCompanyId
    )

    const updatedUserAuthenticated: UserAuthenticated = {
      ...userAuthenticated,
      attendCampaigns: userAttendCampaigns,
      departments: userDepartments,
      isAdmin: userAuthenticated.companies?.some(
        company =>
          company.id === currentCompanyId && (company.role.includes('ADMIN') || company.role.includes('MASTER'))
      ),
      role: userAuthenticated.companies?.find(company => company.id === currentCompanyId)?.role[0] || null
    } as UserAuthenticated

    localStorage.setItem('devchat_app_userAuthenticated', JSON.stringify(updatedUserAuthenticated))

    yield put(updateUserAction.success({ userAuthenticated: updatedUserAuthenticated }))

    yield navigate(`/select-department?companyId=${currentCompanyId}`)
  } catch (error) {
    console.log('error', error)
    yield toast({ type: 'error', message: t('translation:somethingWentWrong') })
    yield put(updateUserAction.failure())
  }
}

export async function isUserBelongsToCompany(companyId: string, user: Partial<UserAuthenticated>) {
  const companies = user?.companies
  if (!companies?.length) {
    return false
  }
  const belongs = companies.some(company => company.id === companyId)
  return belongs
}

async function isAllowedUserOnCompany(companyId: string, user: Partial<UserAuthenticated>) {
  const companies = user?.companies
  if (!companies?.length) {
    return false
  }
  const company = companies.find(company => company.id === companyId)
  if (!company) {
    return false
  }
  if (!company?.role) {
    return false
  }
  const allowed =
    company?.role.includes('ADMIN') || company?.role.includes('OPERATOR') || company?.role.includes('MASTER')
  return allowed
}
